import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NewMemberBlock } from 'src/components/settings/NewMemberBlock';
export default function AddTeamMemberModal(_ref) {
  let _ref$customTrigger = _ref.customTrigger,
    customTrigger = _ref$customTrigger === void 0 ? undefined : _ref$customTrigger,
    handleEditModalSuccess = _ref.handleEditModalSuccess;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '269-add-teammember-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('team_page.add_new_team_member')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger || defaultTrigger,
    title: t('team_page.add_new_team_member'),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(NewMemberBlock, {
    teamMemberPage: true,
    handleEditModalSuccess: handleEditModalSuccess
  }));
}
AddTeamMemberModal.propTypes = {
  customTrigger: PropTypes.node
};